module.exports = __webpack_public_path__ + "img/dinkenclave-9.8eb8cfe0.jpeg";